import { baseAPI } from 'services/baseApi';

export const chatApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getConversations: builder.query({
      query: ({ limit = 100, from = 1, searchChat = '' }) => ({
        url: `chats/recent-chats?page=${from}&page-size=${limit}&search=${searchChat}`,
        method: 'GET'
      }),
      providesTags: ['CONVERSATION_LIST']
    }),
    getMessages: builder.query({
      query: ({ limit = 15, from = 1, id, searchMessage = '' }) => ({
        url: `chats/messages/${id}?page=${from}&page-size=${limit}&search=${searchMessage}`,
        method: 'GET',
        // Sort messages in descending order (latest first)
        transformResponse: (response) => ({
          ...response,
          messages: response.messages.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        })
      }),
      providesTags: ['MESSAGE_LIST']
    }),
    sendMessage: builder.mutation({
      query: (payload) => ({
        url: 'chats',
        method: 'POST',
        body: payload,
        // Important: Use FormData for file uploads
        headers: payload instanceof FormData ? {} : { 'Content-Type': 'application/json' }
      }),
      invalidatesTags: ['MESSAGE_LIST', 'CONVERSATION_LIST']
    }),
    editMessage: builder.mutation({
      query: ({ messageId, content }) => ({
        url: `chats/update-message/${messageId}`,
        method: 'PUT',
        body: { content }
      }),
      invalidatesTags: ['MESSAGE_LIST']
    }),
    deleteMessage: builder.mutation({
      query: (messageId) => ({
        url: `chats/${messageId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['MESSAGE_LIST']
    }),
    createChatRoom: builder.mutation({
      query: (payload) => ({
        url: 'chat-rooms',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['CONVERSATION_LIST']
    })
  })
});

export const {
  useGetConversationsQuery,
  useLazyGetMessagesQuery,
  useGetMessagesQuery,
  useCreateChatRoomMutation,
  useSendMessageMutation,
  useEditMessageMutation,
  useDeleteMessageMutation
} = chatApi;
